var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loadingPortfolioInfo > 0)?_c('BusyIndicator'):(_vm.policy)?_c('CycleChangePolicy',{attrs:{"policy":_vm.policy,"text-content":_vm.textContent,"reasons":_vm.reasons,"submit-state":_vm.submitState,"is-cancel-form":""},on:{"submit":_vm.handleSubmit}}):_c('p',[_vm._v(_vm._s(_vm.dictionaryService.phrases['forms-integration-error']))])
}
var staticRenderFns = []

export { render, staticRenderFns }